// Currency: South African Rand with "R " prefix
export const formatCurrency = (v) => {
  const n = Number(v || 0);
  return `R ${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Date: MM/DD/YYYY
export const formatDate = (v) => {
  if (!v) return "—";
  const d = typeof v === "string" ? new Date(v) : v;
  if (Number.isNaN(d.getTime())) return "—";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

// yyyy-mm to human "Mar 2026"
export const formatPeriod = (p) => {
  if (!p) return "—";
  const [y, m] = p.split("-").map(Number);
  const names = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  return `${names[(m || 1) - 1]} ${y}`;
};

// Get today period yyyy-mm
export const currentPeriod = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

// Build list of periods around today
export const periodOptions = (before = 6, after = 6) => {
  const arr = [];
  const now = new Date();
  for (let i = -before; i <= after; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    arr.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
  }
  return arr;
};
